import { getPreferences } from '../../containers/User/sagas';
import { residentsPreferencesCollectionRef } from '../../firebase/collection/collectionReferences';

export default class GetResidentsFavoritesUseCase {
  static *get(successCallback, failureCallback) {
    yield* getPreferences(residentsPreferencesCollectionRef, successCallback, failureCallback);
  }
}
